import { render } from "./SVGArrowLeft.vue?vue&type=template&id=7c4a670a&ts=true"
import script from "./SVGArrowLeft.vue?vue&type=script&lang=ts"
export * from "./SVGArrowLeft.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__